import React, { useState } from "react";
import "./Content.scss";

const Content = ({ isChecked, setIsChecked }) => {
  // Toggle the checkbox state
  const toggleTerms = () => {
    setIsChecked(!isChecked);
  };

  return (
    <div className="content">
      <div className="container">
        <div>
          <h1>Search for unclaimed money</h1>
          <p>
            You can search for unclaimed money using our online search facility
            based on the Owner's name, suburb and the Organisation where the
            unclaimed money was held.&nbsp;Should you wish to search other
            sources of unclaimed money, please refer to&nbsp;
            <a
              href="https://www.moneysmart.gov.au/tools-and-resources/find-unclaimed-money"
              target="_blank"
              rel="noopener noreferrer"
            >
              ASIC's MoneySmart website
            </a>
            .
          </p>
          <p> To assist you in your claim please provide a list of all addresses including post office boxes that you may have been associated with for the listed unclaimed money record.</p>

          <h3>Terms and Conditions</h3>

          <p>
            Under the{" "}
            <a
              href="https://www.legislation.wa.gov.au/legislation/statutes.nsf/main_mrtitle_1010_homepage.html"
              target="_blank"
              title="Unclaimed Money Act 1990"
              rel="noopener noreferrer"
            >
              Unclaimed Money Act 1990
            </a>
            , we must publish each sum of unclaimed money including the identity
            of its owner (if known).
          </p>

          <p>
            By accessing the unclaimed money search facilities, you agree you
            will not:
          </p>

          <ul>
            <li>
              use the information for any purpose other than its intended use;
            </li>
            <li>
              knowingly contravene the provisions of any privacy legislation
              governing the use of information.
            </li>
          </ul>
        </div>
        <div className="agree-checkbox-container">
          <div className="checkbox">
            <label>
              <input
                id="agreeTermsCheckBox"
                type="checkbox"
                checked={isChecked}
                onChange={toggleTerms}
                className="ng-pristine ng-untouched ng-valid ng-empty"
              />
              <strong>I agree to the Terms &amp; Conditions</strong>
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Content;
